import Icon from './Icon'
import styled from 'styled-components/macro'
import { caption } from 'styles/mixins/textstyles'

const Star = styled(Icon).attrs({
  symbol: 'star',
})`
  width: 1.4rem;
  height: 1.4rem;
  flex-shrink: 0;
  margin-right: 0.2rem;

  svg {
    width: 100%;
    color: ${(props) => props.theme.colors.greyBase};
  }
`

const StarFull = styled(Star).attrs({ palette: 'star' })``

const StarBack = styled(Star).attrs({ palette: 'grey', shade: 'light' })`
  opacity: 1;
`

const StarEmpty = styled(Star)`
  stroke: none !important;
  fill: none !important;
`

const PercentWidth = styled.div`
  display: flex;
  overflow: hidden;
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  bottom: 0;
  right ${(props) => 100 - props.percent}%;
`

const StarSlots = styled.div`
  display: flex;
  position: relative;
  z-index: 1;
`

const Backs = styled.div`
  display: flex;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 0;
`

const StarsStacker = styled.div`
  display: inline-block;
  position: relative;
  font-size: 1.5rem;
`

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const RatingCount = styled.div`
  ${(props) => caption(props.theme.colors.black, 'medium')}

  margin-left: .4rem;
`

const StarRating = ({ rating, ratingCount }) => {
  const percent = rating && ratingCount !== 0 ? (rating / 5) * 100 : 0

  return (
    <Wrapper>
      <StarsStacker>
        <Backs>
          <StarBack />
          <StarBack />
          <StarBack />
          <StarBack />
          <StarBack />
        </Backs>
        <StarSlots>
          <StarEmpty />
          <StarEmpty />
          <StarEmpty />
          <StarEmpty />
          <StarEmpty />
        </StarSlots>
        <PercentWidth percent={percent}>
          <StarFull />
          <StarFull />
          <StarFull />
          <StarFull />
          <StarFull />
        </PercentWidth>
      </StarsStacker>
      <RatingCount>({ratingCount || 0})</RatingCount>
    </Wrapper>
  )
}

export default StarRating
